import type { AlternativeTextFormFieldFragment } from "../../client/generated";
import type { ComponentProps } from "react";
import { Textarea } from "@acdc2/ui/components/textarea";
import { useTranslation } from "react-i18next";
import { AlternativeTextPredictionButton } from "./AlternativeTextPredictionButton";
import { ValueMissingFormMessage } from "../../ui/forms";
import {
  FormControl,
  FormField,
  FormLabel,
} from "@acdc2/ui/components/access-form";

type Props = ComponentProps<"textarea"> & {
  fragment: AlternativeTextFormFieldFragment;
  onPrediction: (text: string) => void;
};

export function AlternativeTextFormField({
  fragment,
  onPrediction,
  ...props
}: Props) {
  const { t } = useTranslation();

  return (
    <FormField name="altText">
      <FormLabel>{t("AlternativeTextFormField.label")}</FormLabel>
      <FormControl asChild>
        <Textarea required rows={8} {...props} />
      </FormControl>
      <ValueMissingFormMessage />
      <AlternativeTextPredictionButton
        fragment={fragment}
        onAccept={onPrediction}
      />
    </FormField>
  );
}
